import { useState } from 'react';
import { CexAPI } from '../../../store/createStore';

enum EState {
  normal,
  loading,
  success,
}

interface IUseSecretCodeProps {
  exchange: string | undefined;
  authToken: string;
  loggedIn: boolean;
  onSuccess(): void;
  onNotify: (input: any) => void;
}
/**
 * Secret code with processing
 */
const UseSecretCode = ({
  exchange,
  authToken,
  loggedIn,
  onSuccess,
  onNotify,
}: IUseSecretCodeProps) => {
  const [code, setCode] = useState<string>('');
  const [state, setState] = useState<EState>(EState.normal);

  const onSubmit = async () => {
    if (!loggedIn) {
      onNotify({
        kind: 'error',
        message: 'Connect your wallet to redeem points',
      });
    }
    if (state == EState.normal && loggedIn && exchange) {
      setState(EState.loading);
      const { status, claimedPoints, message } = await CexAPI.redeemCode(
        authToken,
        exchange,
        code
      );
      if (status) {
        onSuccess();
        setState(EState.success);
        onNotify({
          kind: 'info',
          message: `Successfully added ${claimedPoints} points`,
        });
      } else {
        setState(EState.normal);
        onNotify({
          kind: 'error',
          message: message || 'Error',
        });
      }
    }
  };

  return (
    <div className='points__body__item__secret'>
      {state == EState.normal && (
        <>
          <input
            type='text'
            className='points__body__item__secret__code'
            value={code}
            onChange={(e) => setCode(e.target.value)}
          />
          <div
            className='points__body__item__icon points__body__item__icon--code points__body__item__icon--clickable'
            onClick={onSubmit}
          >
            💰
          </div>
        </>
      )}
      {state === EState.loading && <div>loading...</div>}
      {state === EState.success && (
        <div className='points__body__item__icon points__body__item__icon--true icon-check-circle' />
      )}
    </div>
  );
};

export default UseSecretCode;
